<template>
  <Teleport to="body">
    <div v-if="open" class="modal-backdrop">
      <div
        class="modal-content"
        @keydown.esc="closeOnEscape"
        tabindex="0"
        ref="modalContent"
      >
        <slot />
        <button
            v-if="!props.blocking"
            class="modal-close"
            @click="close"
          >×</button>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { onMounted, onBeforeUnmount, ref } from 'vue'

const props = defineProps({
  open: Boolean,
  blocking: { type: Boolean, default: false },
})
const emits = defineEmits(['close'])
const modalContent = ref(null)

const close = () => emits('close')

const handleClickOutside = (e) => {
  if (!props.blocking && modalContent.value && !modalContent.value.contains(e.target)) {
  close()
}
}

const closeOnEscape = (e) => {
  if (!props.blocking && e.key === 'Escape') close()
}

onMounted(() => {
  document.addEventListener('mousedown', handleClickOutside)
})

onBeforeUnmount(() => {
  document.removeEventListener('mousedown', handleClickOutside)
})
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  border-radius: 6px;
  padding: 20px;
  max-width: 500px;
  width: 90%;
  position: relative;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.modal-close {
  position: absolute;
  top: 10px;
  right: 14px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}
</style>
